import React from "react";

/**
 * Renders simple markdown (bold, italic, links) into React elements.
 * Supports: **bold**, *italic*, [text](url)
 */
export function renderMarkdown(text: string): React.ReactNode[] {
  // Combined regex: links, bold, italic
  const regex = /\[([^\]]+)\]\(([^)]+)\)|\*\*(.+?)\*\*|\*(.+?)\*/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    // Push text before match
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    if (match[1] !== undefined && match[2] !== undefined) {
      // Link: [text](url)
      parts.push(
        <a
          key={match.index}
          href={match[2]}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline underline-offset-2 hover:text-primary/80"
        >
          {match[1]}
        </a>
      );
    } else if (match[3] !== undefined) {
      // Bold: **text**
      parts.push(<strong key={match.index} className="font-bold">{match[3]}</strong>);
    } else if (match[4] !== undefined) {
      // Italic: *text*
      parts.push(<em key={match.index} className="italic">{match[4]}</em>);
    }

    lastIndex = match.index + match[0].length;
  }

  // Push remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
}
